module.exports = __webpack_public_path__ + "static/media/content_1.9d5d979d.png";